import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { MachineryCard } from "@/components/MachineryCard";
import { Input } from "@/components/ui/input";
import api from "@/lib/api";
import { Search, SlidersHorizontal } from "lucide-react";

const CATEGORIES = [
  ["", "Todas"], ["excavadora", "Excavadoras"], ["cargador", "Cargadores"],
  ["camion_minero", "Camiones Mineros"], ["retroexcavadora", "Retroexcavadoras"],
  ["grua", "Grúas"], ["compactadora", "Compactadoras"], ["otro", "Otros"],
];

export default function Catalog() {
  const [params, setParams] = useSearchParams();
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const category = params.get("category") || "";
  const sector = params.get("sector") || "";
  const listing = params.get("listing_type") || "";

  const load = () => {
    const q = {};
    if (category) q.category = category;
    if (sector) q.sector = sector;
    if (listing) q.listing_type = listing;
    if (search) q.search = search;
    api.get("/machinery", { params: q }).then((r) => setItems(r.data));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [category, sector, listing]);

  const setFilter = (k, v) => {
    const next = new URLSearchParams(params);
    if (v) next.set(k, v); else next.delete(k);
    setParams(next);
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="bg-[#0A0A0A] text-white grain relative">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-16">
          <div className="overline text-brand mb-2">Catálogo completo</div>
          <h1 className="font-display font-black text-5xl md:text-6xl tracking-tighter">NUESTRA FLOTA</h1>
          <p className="text-white/60 mt-3 max-w-xl">Filtra por categoría, sector y modalidad para encontrar el equipo ideal.</p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10">
        {/* Filters */}
        <div className="flex flex-col lg:flex-row gap-4 mb-8">
          <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative flex-1">
            <Search size={18} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
            <Input data-testid="catalog-search" placeholder="Buscar por nombre, marca..." value={search}
              onChange={(e) => setSearch(e.target.value)} className="pl-10 h-11" />
          </form>
          <div className="flex gap-3">
            <select value={sector} onChange={(e) => setFilter("sector", e.target.value)} data-testid="filter-sector"
              className="h-11 px-3 bg-background border border-input text-sm">
              <option value="">Todo sector</option>
              <option value="mineria">Minería</option>
              <option value="construccion">Construcción</option>
            </select>
            <select value={listing} onChange={(e) => setFilter("listing_type", e.target.value)} data-testid="filter-listing"
              className="h-11 px-3 bg-background border border-input text-sm">
              <option value="">Alquiler y venta</option>
              <option value="alquiler">Alquiler</option>
              <option value="venta">Venta</option>
            </select>
          </div>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          {CATEGORIES.map(([k, l]) => (
            <button key={k} onClick={() => setFilter("category", k)} data-testid={`cat-filter-${k || "all"}`}
              className={`px-4 py-2 text-sm font-semibold border transition-colors ${category === k ? "bg-brand text-black border-brand" : "border-border hover:border-brand"}`}>
              {l}
            </button>
          ))}
        </div>

        <div className="flex items-center gap-2 text-sm text-muted-foreground mb-6">
          <SlidersHorizontal size={14} /> {items.length} equipos encontrados
        </div>

        {items.length === 0 ? (
          <div className="py-24 text-center text-muted-foreground">No se encontraron equipos con estos filtros.</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-testid="catalog-grid">
            {items.map((m) => <MachineryCard key={m.id} m={m} />)}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
